import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import ChatLi from "./ChatLi";
import Hotkeys from 'react-hot-keys';
import {pickFromQueue} from "../../actions/actions";
import { useNavigate } from "react-router-dom";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class PendingChats extends Component {

    constructor(props) {
        super(props);
        this.state={
            clicked:true
        }
        this.handleOnClick=this.handleOnClick.bind(this);
		this.pickFromQueueFunc=this.pickFromQueueFunc.bind(this);
    }
    handleOnClick(){
        this.setState({
            clicked:!this.state.clicked
        });
    }
	pickFromQueueFunc(){
		var getChats=this.props.chatprop.activeChats.filter(chat=>chat.status=='P' & chat.supervised!=1);
		var getFirstChat = Object.keys(getChats).sort((a, b) => a.pending_time > b.pending_time ? 1:-1);
		var getChat = getChats[getFirstChat[0]];
		var id = getChat.id;
		//console.log(id);
        this.props.dispatch(pickFromQueue(id));
        this.props.navigate("/chat/"+id);
    }

    render() {
        const { t } = this.props;

                var chatData=this.props.chatprop.activeChats.filter(chat=>chat.status=='P' & chat.supervised!=1);

                return (
				<>
	<Hotkeys 
      keyName="ctrl+alt+j" 
      onKeyDown={(keyName, e, handle) => {
        e.preventDefault();
        this.pickFromQueueFunc();
      }}
      >
    </Hotkeys>
				
                    <React.Fragment>
                        <div className="chat-list-header" onClick={() => this.handleOnClick()}>
                                <span className={"chat-list-header-arrow "+(this.state.clicked==false ? "closed-arrow" : "")}>
                                    <div>
                                        <svg width="20px" fill="#61657b" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <g >
                                                <path stroke-width="1" stroke="#61657b" d="M 4 6.2910156 L 3.2910156 7 L 3.6464844 7.3535156 L 10 13.708984 L 16.353516 7.3535156 L 16.708984 7 L 16 6.2910156 L 15.646484 6.6464844 L 10 12.291016 L 4.3535156 6.6464844 L 4 6.2910156 z " />
                                            </g>
                                        </svg>

                                    </div>
                                </span>
                            <span className="chat-list-header-name ">
                                    Queue (<span className="chat-list-header-count">{this.props.chatCount}</span>)
                                </span>

                        </div>
                        <div className={"chat-list-container "+(this.state.clicked==false ? "chat-list-container-closed" : "")}>
                            {Object.keys(chatData).sort((a, b) => a.pending_time > b.pending_time ? 1:-1).map(chat => {
                                return <ChatLi closeChat={this.props.closeChat} data={chatData[chat]} selected_id={this.props.selected_id}/>
                            })}
                        </div>

                    </React.Fragment>
					</>
                )



    }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <PendingChats {...props} navigate={navigate} />
}

export default WithNavigate

//export default withTranslation()(PendingChats);
